import { CardFragment } from 'apps/shared/scripts/graphql/fragments/CardFragment.generated';

import CardShare from '../CardShare';

import CardDelivery from './CardDelivery';
import CardSummary from './CardSummary';

interface Props {
  card: CardFragment;
}

const CardArchive = ({ card }: Props) => {
  return (
    <>
      <CardSummary card={card} />
      <CardDelivery cardId={card.id} />
      <CardShare />
    </>
  );
};

CardArchive.displayName = 'CardArchive';

export default CardArchive;
